import _ from 'lodash'
import moment from 'moment'
import StringMask from 'string-mask'
import { getSalseForceFieldType } from './getSalseForceFieldType'
const { HDate } = require('@hebcal/core/dist/index')

export const DATE_TIME_CONF = [
  {
    key: 0,
    text: 'DD/MM/YYYY HH:mm:ss',
    value: {
      day: 'DD',
      month: 'MM',
      year: 'YYYY',
      hour: 'HH',
      minute: 'mm',
      second: 'ss',
      custom: '',
      dateSeparator: '/',
      timeSeparator: ':',
    },
  },
  {
    key: 19,
    text: 'DD/MM/YYYY HH:mm A',
    value: {
      day: '',
      month: '',
      year: '',
      hour: '',
      minute: '',
      second: '',
      custom: 'DD/MM/YYYY hh:mm A',
      dateSeparator: '',
      timeSeparator: '',
    },
  },
  {
    key: 25,
    text: 'YYYY/MM/DD',
    value: {
      day: '',
      month: '',
      year: '',
      hour: '',
      minute: '',
      second: '',
      custom: 'YYYY/MM/DD',
      dateSeparator: '/',
      timeSeparator: ':',
    },
  },
  {
    key: 26,
    text: 'YYYY/DD/MM',
    value: {
      day: '',
      month: '',
      year: '',
      hour: '',
      minute: '',
      second: '',
      custom: 'YYYY/DD/MM',
      dateSeparator: '/',
      timeSeparator: ':',
    },
  },
  {
    key: 20,
    text: 'MM/DD/YYYY HH:mm A',
    value: {
      day: '',
      month: '',
      year: '',
      hour: '',
      minute: '',
      second: '',
      custom: 'MM/DD/YYYY hh:mm A',
      dateSeparator: '',
      timeSeparator: '',
    },
  },
  {
    key: 1,
    text: 'YYYY-MM-DDThh:mm:ssZ',
    value: {
      day: '',
      month: '',
      year: '',
      hour: '',
      minute: '',
      second: '',
      custom: 'YYYY-MM-DDThh:mm:ssZ',
      dateSeparator: '-',
      timeSeparator: ':',
    },
  },
  {
    key: 2,
    text: 'hh:mm:ss',
    value: {
      day: '',
      month: '',
      year: '',
      hour: '',
      minute: '',
      second: '',
      custom: 'hh:mm:ss',
      dateSeparator: '-',
      timeSeparator: ':',
    },
  },
  {
    key: 3,
    text: '8:30 PM',
    value: {
      day: '',
      month: '',
      year: '',
      hour: '',
      minute: '',
      second: '',
      custom: 'LT',
      dateSeparator: '-',
      timeSeparator: ':',
    },
  },
  {
    key: 4,
    text: '8:30:25 PM',
    value: {
      day: '',
      month: '',
      year: '',
      hour: '',
      minute: '',
      second: '',
      custom: 'LTS',
      dateSeparator: '-',
      timeSeparator: ':',
    },
  },
  {
    key: 5,
    text: '09/04/1986',
    value: {
      day: '',
      month: '',
      year: '',
      hour: '',
      minute: '',
      second: '',
      custom: 'L',
      dateSeparator: '-',
      timeSeparator: ':',
    },
  },
  {
    key: 6,
    text: '9/4/1986',
    value: {
      day: '',
      month: '',
      year: '',
      hour: '',
      minute: '',
      second: '',
      custom: 'l',
      dateSeparator: '-',
      timeSeparator: ':',
    },
  },
  {
    key: 13,
    text: 'DD/MM/YYYY',
    value: {
      day: '',
      month: '',
      year: '',
      hour: '',
      minute: '',
      second: '',
      custom: 'DD/MM/YYYY',
      dateSeparator: '-',
      timeSeparator: ':',
    },
  },
  {
    key: 18,
    text: 'MM/DD/YYYY',
    value: {
      day: '',
      month: '',
      year: '',
      hour: '',
      minute: '',
      second: '',
      custom: 'MM/DD/YYYY',
      dateSeparator: '-',
      timeSeparator: ':',
    },
  },
  {
    key: 14,
    text: 'D/M/YYYY',
    value: {
      day: '',
      month: '',
      year: '',
      hour: '',
      minute: '',
      second: '',
      custom: 'D/M/YYYY',
      dateSeparator: '-',
      timeSeparator: ':',
    },
  },
  {
    key: 7,
    text: 'September 4, 1986',
    value: {
      day: '',
      month: '',
      year: '',
      hour: '',
      minute: '',
      second: '',
      custom: 'LL',
      dateSeparator: '-',
      timeSeparator: ':',
    },
  },
  {
    key: 8,
    text: 'Sep 4, 1986',
    value: {
      day: '',
      month: '',
      year: '',
      hour: '',
      minute: '',
      second: '',
      custom: 'll',
      dateSeparator: '-',
      timeSeparator: ':',
    },
  },
  {
    key: 9,
    text: 'September 4, 1986 8:30 PM',
    value: {
      day: '',
      month: '',
      year: '',
      hour: '',
      minute: '',
      second: '',
      custom: 'LLL',
      dateSeparator: '-',
      timeSeparator: ':',
    },
  },
  {
    key: 10,
    text: 'Sep 4, 1986 8:30 PM',
    value: {
      day: '',
      month: '',
      year: '',
      hour: '',
      minute: '',
      second: '',
      custom: 'lll',
      dateSeparator: '-',
      timeSeparator: ':',
    },
  },
  {
    key: 11,
    text: 'Thursday, September 4, 1986 8:30 PM',
    value: {
      day: '',
      month: '',
      year: '',
      hour: '',
      minute: '',
      second: '',
      custom: 'LLLL',
      dateSeparator: '-',
      timeSeparator: ':',
    },
  },
  {
    key: 12,
    text: 'Thu, Sep 4, 1986 8:30 PM',
    value: {
      day: '',
      month: '',
      year: '',
      hour: '',
      minute: '',
      second: '',
      custom: 'llll',
      dateSeparator: '-',
      timeSeparator: ':',
    },
  },
  {
    key: 13,
    text: 'HH:mm:ss',
    value: {
      day: '',
      month: '',
      year: '',
      hour: '',
      minute: '',
      second: '',
      custom: 'HH:mm:ss',
      dateSeparator: '-',
      timeSeparator: ':',
    },
  },
  {
    key: 14,
    text: 'HH:mm:ssZ',
    value: {
      day: '',
      month: '',
      year: '',
      hour: '',
      minute: '',
      second: '',
      custom: 'HH:mm:ssZ',
      dateSeparator: '-',
      timeSeparator: ':',
    },
  },
  {
    key: 15,
    text: 'HH:mm',
    value: {
      day: '',
      month: '',
      year: '',
      hour: '',
      minute: '',
      second: '',
      custom: 'HH:mm',
      dateSeparator: '-',
      timeSeparator: ':',
    },
  },
  {
    key: 16,
    text: 'DD/MM/YYYY HH:mm',
    value: {
      day: '',
      month: '',
      year: '',
      hour: '',
      minute: '',
      second: '',
      custom: 'DD/MM/YYYY HH:mm',
      dateSeparator: '-',
      timeSeparator: ':',
    },
  },
  {
    key: 17,
    text: 'YYYY-MM-DD',
    value: {
      day: '',
      month: '',
      year: '',
      hour: '',
      minute: '',
      second: '',
      custom: 'YYYY-MM-DD',
      dateSeparator: '-',
      timeSeparator: ':',
    },
  },
  {
    key: 18,
    text: 'hh:mm:ssZ',
    value: {
      day: '',
      month: '',
      year: '',
      hour: '',
      minute: '',
      second: '',
      custom: 'hh:mm:ssZ',
      dateSeparator: '-',
      timeSeparator: ':',
    },
  },
  {
    key: 21,
    text: 'Year(1986)',
    value: {
      day: '',
      month: '',
      year: '',
      hour: '',
      minute: '',
      second: '',
      custom: 'YYYY',
      dateSeparator: '-',
      timeSeparator: ':',
    },
  },
  {
    key: 22,
    text: 'Quarter(3)',
    value: {
      day: '',
      month: '',
      year: '',
      hour: '',
      minute: '',
      second: '',
      custom: 'Q',
      dateSeparator: '-',
      timeSeparator: ':',
    },
  },
  {
    key: 23,
    text: 'Quarter(3rd)',
    value: {
      day: '',
      month: '',
      year: '',
      hour: '',
      minute: '',
      second: '',
      custom: 'Qo',
      dateSeparator: '-',
      timeSeparator: ':',
    },
  },
  {
    key: 24,
    text: 'Month(09)',
    value: {
      day: '',
      month: '',
      year: '',
      hour: '',
      minute: '',
      second: '',
      custom: 'MM',
      dateSeparator: '-',
      timeSeparator: ':',
    },
  },
  {
    key: 24,
    text: 'Day(09)',
    value: {
      day: '',
      month: '',
      year: '',
      hour: '',
      minute: '',
      second: '',
      custom: 'DD',
      dateSeparator: '-',
      timeSeparator: ':',
    },
  },
]

const NUMBER_CONF_EXTRA = [
  {
    key: 0,
    text: '###.###',
    value: {
      digitGroupingSymbol: '.',
      decimalPoint: '',
      decimals: 0,
      sign: false,
      leadingText: '',
      text: '',
    },
  },
  {
    key: 1,
    text: '###.###,#',
    value: {
      digitGroupingSymbol: '.',
      decimalPoint: ',',
      decimals: 1,
      sign: false,
      leadingText: '',
      text: '',
    },
  },
  {
    key: 2,
    text: '###.###,##',
    value: {
      digitGroupingSymbol: '.',
      decimalPoint: ',',
      decimals: 2,
      sign: false,
      leadingText: '',
      text: '',
    },
  },
  {
    key: 3,
    text: '$###.###',
    value: {
      digitGroupingSymbol: '.',
      decimalPoint: '',
      decimals: 0,
      sign: false,
      leadingText: '$',
      text: '',
    },
  },
  {
    key: 4,
    text: '$###.###,#',
    value: {
      digitGroupingSymbol: '.',
      decimalPoint: ',',
      decimals: 1,
      sign: false,
      leadingText: '$',
      text: '',
    },
  },
  {
    key: 5,
    text: '$###.###,##',
    value: {
      digitGroupingSymbol: '.',
      decimalPoint: ',',
      decimals: 2,
      sign: false,
      leadingText: '$',
      text: '',
    },
  },
  {
    key: 6,
    text: '######.#',
    value: {
      digitGroupingSymbol: '',
      decimalPoint: '.',
      decimals: 1,
      sign: false,
      leadingText: '',
      text: '',
    },
  },
  {
    key: 7,
    text: '######,#',
    value: {
      digitGroupingSymbol: '',
      decimalPoint: ',',
      decimals: 1,
      sign: false,
      leadingText: '',
      text: '',
    },
  },
  {
    key: 8,
    text: '######.##',
    value: {
      digitGroupingSymbol: '',
      decimalPoint: '.',
      decimals: 2,
      sign: false,
      leadingText: '',
      text: '',
    },
  },
]

const NUMBER_CONF = [
  {
    key: 0,
    text: '######,##',
    value: {
      digitGroupingSymbol: '',
      decimalPoint: ',',
      decimals: 2,
      sign: false,
      leadingText: '',
      text: '',
    },
  },
  {
    key: 1,
    text: '$###,###.##',
    value: {
      digitGroupingSymbol: ',',
      decimalPoint: '.',
      decimals: 2,
      sign: false,
      leadingText: '$',
      text: '',
    },
  },
  {
    key: 2,
    text: '###,###.##',
    value: {
      digitGroupingSymbol: ',',
      decimalPoint: '.',
      decimals: 2,
      sign: false,
      leadingText: '',
      text: '',
    },
  },
  {
    key: 3,
    text: '$###,###',
    value: {
      digitGroupingSymbol: ',',
      decimalPoint: '.',
      decimals: 0,
      sign: false,
      leadingText: '$',
      text: '',
    },
  },
  {
    key: 4,
    text: '###,###',
    value: {
      digitGroupingSymbol: ',',
      decimalPoint: '.',
      decimals: 0,
      sign: false,
      leadingText: '',
      text: '',
    },
  },
  {
    key: 5,
    text: '$###,###.#',
    value: {
      digitGroupingSymbol: ',',
      decimalPoint: '.',
      decimals: 1,
      sign: false,
      leadingText: '$',
      text: '',
    },
  },
  {
    key: 5,
    text: '###,###.#',
    value: {
      digitGroupingSymbol: ',',
      decimalPoint: '.',
      decimals: 1,
      sign: false,
      leadingText: '',
      text: '',
    },
  },
  {
    key: 6,
    text: "#'###.##",
    value: {
      digitGroupingSymbol: "'",
      decimalPoint: '.',
      decimals: 2,
      sign: false,
      leadingText: '',
      text: '',
    },
  },
  {
    key: 7,
    text: '######',
    value: {
      digitGroupingSymbol: '',
      decimalPoint: '',
      decimals: 0,
      sign: false,
      leadingText: '',
      text: '',
    },
  },
]

const week = {
  1: 'יום שני',
  2: 'יום שלישי',
  3: 'יום רביעי',
  4: 'יום חמישי',
  5: 'יום שישי',
  6: 'יום שבת',
  0: 'יום ראשון',
}

export const fixValueDate = (props, type, value) => {
  let dateFormat = getFormDateFormat(props, 'date')
  if (dateFormat == 'DD/MM/YYYY') {
    value = String(value).split('/')
    if (value.length > 2) {
      let tmp = value[0]
      value[0] = value[1]
      value[1] = tmp
      return value.join('/')
    } else {
      return ''
    }
  }
  return value
}

export const getFormDateFormat = (props, type) => {
  let dateFormat = _.get(props, ['dateFormat'], 'MM/DD/YYYY')
  if (!dateFormat) {
    dateFormat = 'MM/DD/YYYY'
  }
  let timeFormat = parseInt(_.get(props, ['timeFormat'], 12))
  if (!timeFormat) {
    timeFormat = 12
  }
  if (timeFormat == 24) {
    timeFormat = 'HH:mm'
  } else {
    timeFormat = 'hh:mm A'
  }
  if (type == 'datetime') {
    return `${dateFormat} ${timeFormat}`
  } else if (type == 'date') {
    return dateFormat
  } else {
    return timeFormat
  }
}

export const getAccessibilityFormDateFormat = (props, type) => {
  let dateFormat = _.get(props, ['dateFormat'], 'MM/DD/YYYY')
  if (!dateFormat) {
    dateFormat = 'MM/DD/YYYY'
  }
  let timeFormat = parseInt(_.get(props, ['timeFormat'], 12))
  if (!timeFormat) {
    timeFormat = 12
  }
  if (timeFormat == 24) {
    timeFormat = 'HH:mm'
  } else {
    timeFormat = 'hh:mm a'
  }
  dateFormat = String(dateFormat).replace(/D/g, 'd').replace(/Y/g, 'y')
  if (type == 'datetime') {
    return `${dateFormat} ${timeFormat}`
  } else if (type == 'date') {
    return dateFormat
  } else {
    return timeFormat
  }
}

export const getDateFormat = (format, defValue = 'YYYY-MM-DDThh:mm:ssZ') => {
  const conf = _.find(DATE_TIME_CONF, (v) => v.text === format)
  if (conf) {
    if (conf.value.custom) {
      return conf.value.custom
    }
    return [
      [conf.value.day, conf.value.month, conf.value.year].join(conf.value.dateSeparator),
      [conf.value.hour, conf.value.minute, conf.value.second].join(conf.value.timeSeparator),
    ].join(' ')
  } else {
    return defValue
  }
}

const month = {
  0: 'ינואר',
  1: 'פברואר',
  2: 'מרץ',
  3: 'אפריל',
  4: 'מאי',
  5: 'יוני',
  6: 'יולי',
  7: 'אוגוסט',
  8: 'ספטמבר',
  9: 'אוקטובר',
  10: 'נובמבר',
  11: 'דצמבר',
}

export const getTimeFormat = (value) => {
  switch (value) {
    case '24':
      return 'hh:mm'
    case '8:30 PM':
      return 'hh:mm a'
    case '8:30:25 PM':
      return 'hh:mm:ss a'
    default:
      return value
  }
}
export const isAmPm = (value) => {
  switch (value) {
    case '12':
    case 'hh:mm:ssZ':
    case '8:30 PM':
    case '8:30:25 PM':
      return true
    default:
      return false
  }
}

export const formatTableCell = (value, column, isComponent) => {
  let val = ''
  let pre = _.get(column, 'prefix', '') || ''
  let post = _.get(column, 'postfix', '') || ''
  const format = _.get(column, 'format.value')
  const ftType = getSalseForceFieldType(_.get(column, 'field.type'))
  if (ftType == 'number' && (value === 'null' || value === null)) {
    return ''
  }

  try {
    switch (format) {
      case 'text':
        val = String(value)
        break
      case 'lowercase':
        val = String(value).toLowerCase()
        break
      case 'capitalize':
        val = _.map(String(value).split(' '), (c) => c.charAt(0).toUpperCase() + c.substr(1)).join(' ')
        break
      case 'uppercase':
        val = String(value).toUpperCase()
        break
      case 'uppercase_first':
        val = String(value).charAt(0).toUpperCase() + String(value).substr(1)
        break
      case 'jewish_cal':
      case 'jewish_cal_he': {
        let localVal
        if (value) {
          if (String(value).indexOf('-') == -1) {
            let value2 = new Date()
            let parsed = String(value).split(':')
            value2.setHours(parsed[0])
            value2.setMinutes(parsed[1])
            localVal = value2
          } else {
            localVal = value
          }
        } else {
          localVal = value
        }
        let date = moment(localVal)
        if (date.isValid()) {
          let hd = new HDate(date.toDate())
          val = hd.render(format === 'jewish_cal_he' ? 'he-x-NoNikud' : undefined)
        } else {
          val = String(value)
        }
        break
      }
      case 'jewish_cal_v1':
      case 'jewish_cal_v1_he': {
        let localVal
        if (value) {
          if (String(value).indexOf('-') == -1) {
            let value2 = new Date()
            let parsed = String(value).split(':')
            value2.setHours(parsed[0])
            value2.setMinutes(parsed[1])
            localVal = value2
          } else {
            localVal = value
          }
        } else {
          localVal = value
        }
        let date = moment(localVal)
        if (date.isValid()) {
          let hd = new HDate(date.toDate())
          val = [
            hd.getFullYear(),
            ', ',
            hd.render(format === 'jewish_cal_v1_he' ? 'he-x-NoNikud' : undefined, false),
          ].join('')
        } else {
          val = String(value)
        }
        break
      }
      case 'short_hebrew': {
        let localVal
        if (value) {
          if (String(value).indexOf('-') == -1) {
            let value2 = new Date()
            let parsed = String(value).split(':')
            value2.setHours(parsed[0])
            value2.setMinutes(parsed[1])
            localVal = value2
          } else {
            localVal = value
          }
        } else {
          localVal = value
        }
        let date = moment(localVal)
        if (date.isValid()) {
          let dt = new Date(date.toDate())
          val = [week[dt.getDay()] + ', ' + dt.getDate() + ' ' + month[dt.getMonth()] + ' ' + dt.getFullYear()].join('')
        } else {
          val = String(value)
        }
        break
      }
      case 'jewish_cal_gem': {
        let localVal
        if (value) {
          if (String(value).indexOf('-') == -1) {
            let value2 = new Date()
            let parsed = String(value).split(':')
            value2.setHours(parsed[0])
            value2.setMinutes(parsed[1])
            localVal = value2
          } else {
            localVal = value
          }
        } else {
          localVal = value
        }
        let date = moment(localVal)
        if (date.isValid()) {
          let hd = new HDate(date.toDate())
          val = `${week[hd.getDay()]}, ${hd.renderGematriya()}`
        } else {
          val = String(value)
        }
        break
      }
      case 'MM/DD/YYYY HH:mm A':
      case 'DD/MM/YYYY HH:mm A':
      case 'DD/MM/YYYY HH:mm':
      case 'DD/MM/YYYY HH:mm:ss':
      case 'YYYY-MM-DDThh:mm:ssZ':
      case 'hh:mm:ssZ':
      case 'HH:mm:ss':
      case 'HH:mm:ssZ':
      case 'hh:mm:ss':
      case 'HH:mm':
      case '8:30 PM':
      case '8:30:25 PM':
      case '09/04/1986':
      case '9/4/1986':
      case 'DD/MM/YYYY':
      case 'YYYY/MM/DD':
      case 'YYYY/DD/MM':
      case 'D/M/YYYY':
      case 'September 4, 1986':
      case 'Sep 4, 1986':
      case 'September 4, 1986 8:30 PM':
      case 'Sep 4, 1986 8:30 PM':
      case 'Thursday, September 4, 1986 8:30 PM':
      case 'YYYY-MM-DD':
      case 'Year(1986)':
      case 'Quarter(3)':
      case 'Quarter(3rd)':
      case 'Month(09)':
      case 'Day(09)':
      case 'Thu, Sep 4, 1986 8:30 PM': {
        let localVal
        if (value) {
          if (String(value).indexOf('-') == -1) {
            let value2 = new Date()
            let parsed = String(value).split(':')
            value2.setHours(parsed[0])
            value2.setMinutes(parsed[1])
            localVal = value2
          } else {
            localVal = value
          }
        } else {
          localVal = value
        }
        let date = moment(localVal)
        if (date.isValid()) {
          const conf = _.find(DATE_TIME_CONF, (v) => v.text === format)
          if (conf) {
            if (conf.value && conf.value.custom) {
              val = date.format(conf.value.custom)
            } else {
              val = date.format(
                [
                  [conf.value.day, conf.value.month, conf.value.year].join(conf.value.dateSeparator),
                  [conf.value.hour, conf.value.minute, conf.value.second].join(conf.value.timeSeparator),
                ].join(' ')
              )
            }
          } else {
            val = value
          }
        } else {
          val = value
        }
        break
      }
      case '######':
      case '######.#':
      case '######.##':
      case '######,##':
      case '######,#':
      case '###,###':
      case '###,###.#':
      case '###,###.##':
      case '$###,###':
      case "#'###.##":
      case '$###,###.#':
      case '$###,###.##':
      case '###.###':
      case '###.###,#':
      case '###.###,##':
      case '$###.###':
      case '$###.###,#':
      case '$###.###,##': {
        let number = parseFloat(String(value).replace(/[^\d.-]/g, '')) || 0
        if (typeof value === 'string') return `${pre}${value}${post}`

        const opt =
          NUMBER_CONF.find((v) => v.text === format) ||
          NUMBER_CONF_EXTRA.find((v) => v.text === format) ||
          NUMBER_CONF[0]

        const decimals = column?.decimals ? parseInt(column.decimals, 10) : opt?.value?.decimals || 0

        if (opt?.value?.abs) number = Math.abs(number)

        const groupingSymbol = opt?.value?.digitGroupingSymbol
        const decimalPoint = opt?.value?.decimalPoint

        let modifiedNumber = number < 0 ? Math.floor(number * -1) * -1 : Math.floor(number)

        let integerPart = modifiedNumber.toString()
        const decimalPart = decimals > 0 ? number.toFixed(decimals).split('.')[1] : ''

        let formatted = integerPart.replace(/\B(?=(\d{3})+(?!\d))/g, groupingSymbol)

        if (decimals > 0) {
          formatted += decimalPoint + decimalPart
        }

        val = `${opt?.value?.leadingText || ''}${formatted}`
        break
      }

      case 'Mask': {
        try {
          if (value) {
            let mask = new StringMask(_.get(column, 'format.mask', ''))
            val = mask.apply(String(value))
            if (String(val).length < String(value).length) {
              val = value
            }
          }
        } catch (error) {}
        break
      }
      default:
        val = value
        let num = parseFloat(val)
        if (!_.isNaN(num) && Number(val)) {
          if (_.isNaN(num)) {
            return `${pre}${Number(num)}${post}`
          } else {
            return `${pre}${num}${post}`
          }
        }
    }
  } catch (error) {
    console.error(error)
  }

  if (isComponent && (val === '' || val === null)) {
    return (
      <>
        <span className="ft-number-value" dir="ltr">
          {val}
        </span>
      </>
    )
  } else if (isComponent) {
    return (
      <>
        {pre}
        <span className="ft-number-value" dir="ltr">
          {val}
        </span>
        {post}
      </>
    )
  } else if (val === '' || val === null) {
    return val
  } else {
    return `${pre}${val}${post}`
  }
}
